const OPTIONS_DEFAULT = {
  arrayMaxElements: 99,
  assignSymbol: "→",
  clear: false,
  colorize: true,
  console: true,
  depth: 20,
  exit: false,
  immediate: false,
  indent: "ˑˑ",
  indentPad: 1,
  mapMaxEntries: 99,
  objectMaxProps: 99,
  quotesEnd: `"`,
  quotesStart: `"`,
  returns: true,
  setMaxValues: 99,
  stdout: false,
  stringMaxLength: 360,
};

export default OPTIONS_DEFAULT;
